export enum EDownloadFileStatus {
  BEGIN = 'BEGIN',
  QUEUE_COMPLETED = 'QUEUE_COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCEEDED = 'SUCCEEDED',
  ERROR = 'ERROR',
  NO_DATA_FOUND = 'NO_DATA_FOUND',
  PARTIALLY_COMPLETED = 'PARTIALLY_COMPLETED',
  COMPLETED = 'COMPLETED',
}

export type TDownloadFile = {
  id: string;
  fileName: string;
  status: EDownloadFileStatus;
  apiFunction: () => Promise<void> | void;
  date: Date;
};
export type TDownloadFileQueue = {
  id: string;
  fileName: string;
  status: EDownloadFileStatus;
  apiQueueFunction: () => Promise<EDownloadFileStatus>;
  apiCheckStatusFunction: (exportOperationInfo?: any) => Promise<EDownloadFileStatus>;
  date: Date;
};
export type TDownloadManager = {
  count: number;
  downloadFiles: TDownloadFile[];
  downloadFilesQueue?: TDownloadFileQueue[];
  panelOpen: boolean;
};
